export default __webpack_public_path__ + "static/media/Avatar-5-noback.f39917b6.png";